import { LoggingService } from './logging.service';
import { InjectionToken, NgModule, APP_INITIALIZER } from '@angular/core';
import {
  MsalService,
  MsalModule,
  MsalInterceptor,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import {
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';

const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

export function initializerFactory(
  env: ConfigService,
  configUrl: string,
  apiService: ApiService,
  loggingService: LoggingService
): any {
  // APP_INITIALIZER, except a function return which will return a promise
  // APP_INITIALIZER, angular doesnt starts application untill it completes
  const promise = env.init(configUrl).then((value) => {
    apiService.setAPIEndPoint(env.getSettings('apiEndPoint'));
    loggingService.setAppInsights(env.getSettings('instrumentationKey'));
  });
  return () => promise;
}

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;
export function loggerCallback(logLevel: LogLevel, message: string) {
  //console.log(message);
}
export function MSALInstanceFactory(
  config: ConfigService
): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.getSettings('clientID'),
      authority: config.getSettings('authority'),
      redirectUri: config.getSettings('redirectUri'),
      postLogoutRedirectUri: config.getSettings('postLogoutRedirectUri'),
    },
    cache: {
      cacheLocation: config.getSettings('cacheLocation'), // sessionStorage
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALGuardConfigFactory(
  config: ConfigService
): MsalGuardConfiguration {
  const consentScopes = config.getSettings('consentScopes');
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: consentScopes,
    },
  };
}

export function MSALInterceptorConfigFactory(
  config: ConfigService
): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  const maps = config.getSettings('protectedResourceMap');
  maps.map((m: any) => {
    protectedResourceMap.set(m[0], m[1]);
  });

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

@NgModule({
  imports: [MsalModule],
  providers: [
    ConfigService,
    { provide: AUTH_CONFIG_URL_TOKEN, useValue: '../../assets/config.json' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializerFactory,
      deps: [ConfigService, AUTH_CONFIG_URL_TOKEN, ApiService, LoggingService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [ConfigService],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
      deps: [ConfigService],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [ConfigService],
    },
    MsalService,
  ],
})
export class MsalApplicationModule {}
